<ng-container *ngIf="{ darkMode: darkMode$ | async } as ui">
    <div class="slider-panel-bg slider-layer-{{ layer }}" [style.width]="backgroundWidth + '%'" (click)="onClose()"></div>
    <div class="slider-panel slider-layer-{{ layer }}" [style.width]="pageWidth + '%'" [ngClass]="{'bg-dark-900': ui.darkMode, 'bg-white': !ui.darkMode}">
        <div class="slider-panel-close c-pointer" [ngClass]="{'text-dark-600': ui.darkMode}" (click)="onClose()">
            <i class="far fa-lg fa-times"></i>
        </div>
        <ng-content></ng-content>
    </div>
</ng-container>